import React from 'react';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppDialog from '@components/app-dialog/app-dialog.tsx';
import { UnsavedChangesDialogProps } from '@models/unsaved-changes-dialog.model.ts';

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  open,
  isLoading,
  onSave,
  onDiscard,
  onCancel
}) => {
  const { t } = useTranslation();

  return (
    <AppDialog
      open={open}
      size="sm"
      width={440}
      title={t('branding_save_dialog_title')}
      onClose={onCancel}
      content={
        <Typography variant="body2" className="text-(--gray-2)!">
          {t('branding_save_dialog_description')}
        </Typography>
      }
      actions={
        <div className="grid grid-cols-2 gap-3 w-full mt-4">
          <Button
            variant="outlined"
            disabled={isLoading}
            onClick={onDiscard}
            className="min-w-0! max-w-none! w-full! h-11!"
          >
            {t('discard')}
          </Button>
          <Button
            variant="contained"
            loading={isLoading}
            onClick={onSave}
            className="min-w-0! max-w-none! w-full! h-11!"
          >
            {t('save')}
          </Button>
        </div>
      }
    />
  );
};

export default UnsavedChangesDialog;
